var map = {
	"./01.jpg": 460,
	"./02.jpg": 461,
	"./03.jpg": 462,
	"./04.jpg": 463,
	"./05.jpg": 464,
	"./06.jpg": 465,
	"./07.jpg": 466,
	"./08.jpg": 467,
	"./09.jpg": 468,
	"./10.jpg": 469,
	"./11.jpg": 470,
	"./12.jpg": 471,
	"./13.jpg": 472,
	"./14.jpg": 473,
	"./15.jpg": 474,
	"./16.jpg": 475,
	"./17.jpg": 476,
	"./18.jpg": 477,
	"./19.jpg": 478,
	"./20.jpg": 479,
	"./21.jpg": 480,
	"./22.jpg": 481,
	"./23.jpg": 482,
	"./24.jpg": 483,
	"./25.jpg": 484,
	"./26.jpg": 485,
	"./27.jpg": 486,
	"./28.jpg": 487
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders nonrecursive \.(png|jpe?g|svg)$
// module id = 459
// module chunks = 0